'use strict'

import PlotFrost from './plots/frost.js'
import PlotMelting from './plots/melting.js'
import PlotSnow from './plots/snow.js'
import PlotTemperatureDeviation from './plots/temperature-deviation.js'
import PlotTemperatureSeason from './plots/temperature-season.js'
import PlotFrogLaying from './plots/frogs-laying.js'
import PlotGreeneryDaily from './plots/greenery-daily.js'
import PlotGreeneryYearly from './plots/greenery-yearly.js'
import DynamicMenu from './menu.js'
import ExploreMap from './explore.js'
import CensusMapController from './recenser.js'
import MargesGlaciairesMapController from './marges-glaciaires.js'
import PrairiesMapController from './prairies.js'
import BackToTopButton from './back-top.js'

document.onreadystatechange = () => {
  if (document.readyState === 'complete') {
    // Load all available plot types
    new PlotFrost().wire().load()
    new PlotMelting().wire().load()
    new PlotSnow().wire().load()
    new PlotTemperatureDeviation().wire().load()
    new PlotTemperatureSeason().wire().load()
    new PlotFrogLaying().wire().load()
    new PlotGreeneryDaily().wire().load()
    new PlotGreeneryYearly().wire().load()

    // Load menu
    new DynamicMenu().wire().load()

    // Load back to top button
    new BackToTopButton().wire()

    // Load "explore" map and icons
    new ExploreMap().wire().load()

    // Load "recenser" page
    new CensusMapController().wire().load()

    // Load "marges glaciaires" page
    new MargesGlaciairesMapController().wire().load()

    // Load "prairies" map
    new PrairiesMapController().load()
  }
}
